<template>
  <div>
    <!-- <img :src="require('../icons/parkingNotSelected.svg')" class="cluster-img"/> -->
    <p :class="getClass()">
      <b>{{ getNumber() }}</b>
    </p>
  </div>
</template>
  
  <script>
export default {
  props: {
    clusterUsers: {
      type: Array,
      required: true,
    },
    type: String,
  },
  methods: {
    getNumber() {
      return this.$props.clusterUsers.length;
    },
    getClass() {
      if (this.$props.type == "hospital") {
        return "cluster-text-hospital";
      } else {
        if (this.$props.type == "bar") {
          return "cluster-text-bars";
        } else {
          return "cluster-text";
        }
      }
    },
  },
};
</script>
  
  <style>
.cluster-img {
  float: left;
  width: 40px;
  height: 40px;
}
.cluster-text {
  margin: 12px;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background-color: #307ecd;
  color: #fff;
  text-align: center;
  font-size: 10px;
  overflow: hidden;
  line-height: 25px;
}

.cluster-text-bars {
  margin: 12px;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background-color: #db8e47;
  color: #fff;
  text-align: center;
  font-size: 10px;
  overflow: hidden;
  line-height: 25px;
}

.cluster-text-hospital {
  margin: 12px;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background-color: #a74848;
  color: #fff;
  text-align: center;
  font-size: 10px;
  overflow: hidden;
  line-height: 25px;
}
</style>